import naturalCompare from 'natural-compare-lite';

export const sortByText = (a = '', b = '') => {
  const firstString = a?.toLowerCase().trim() || '';
  const secondString = b?.toLowerCase().trim() || '';

  return naturalCompare(firstString, secondString);
};
